import React, { Component } from 'react'
import { Card, Table } from 'react-bootstrap'
import { observer } from 'mobx-react';
import './policy-timeline-table-multiple-la.css'
import ProductConstants from 'constants/ProductConstants';

const NewPolicyTimelineTableMultipleLa = observer(class NewPolicyTimelineTableMultipleLa extends Component {
    constructor(props) {
        super(props);
        this.policyTimeLineRef = React.createRef();
    }

    fetchProductEndMessage = (productName) => {
        switch (productName) {
            case ProductConstants.EASY_PENSION:
            case ProductConstants.FOREVER_PENSION:
            case ProductConstants.SARAL_PENSION:
            case ProductConstants.FOREVER_PENSION_DEFERRED_ANNUITY:
            case ProductConstants.FOREVER_PENSION_IMMEDIATE_ANNUITY:
                return "continues till applicable Life Assured(s) is/are alive"

            default:
                return "plan ends"
        }
    }

    componentDidMount() {
        if (this.props.isKeypressScrollActive) {
            setTimeout(() => {
                this.policyTimeLineRef.current.focus();
            }, 200);
        }
    }

    componentDidUpdate() {
        if (this.props.isKeypressScrollActive) {
            setTimeout(() => {
                this.policyTimeLineRef.current.focus();
            }, 200);
        }
    }

    handlePolicyTableScroll = event => {
        this.policyTimeLineRef.current.focus();
    };

    render() {
        const list = this.props.data
        const headerList = this.props.data?.laHeaderList
        const secHeaderList = this.props.data?.secLaHeaderList
        const yearsKeyData = Object.keys(list?.yearData)
        return (
            <Card className='px-3 policy-timeline-table-card h-100' onScroll={this.handlePolicyTableScroll}>
                <Table className='w-100 policy-timeline-table mb-0 rounded' tabIndex={0} ref={this.policyTimeLineRef}>
                    <thead className='policy-timeline-header'>
                        <tr>
                            <td className='font-size-12 year-label font-weight-bold '>Year</td>
                            <td className='font-size-12 year-label font-weight-bold '>Calendar Year</td>
                            {headerList.map((item, index) =>

                                <td className='font-size-12 year-label font-weight-bold '>Age<br /> [{item.la_name}]</td>
                            )}
                            {secHeaderList.map((item, index) =>

                                <td className='font-size-12 year-label font-weight-bold '>Age<br /> [{item.sec_la_name}]</td>
                            )}
                            <td className='font-size-12 year-label font-weight-bold '>You Pay</td>
                            <td className='font-size-12 year-label font-weight-bold '>You Get</td>
                            {headerList.map((item, index) =>

                                <td className='font-size-12 year-label font-weight-bold '>Life Cover<br /> [{item.la_name}]</td>
                            )}
                            {secHeaderList.map((item, index) =>

                                <td className='font-size-12 year-label font-weight-bold '>Life Cover<br /> [{item.sec_la_name}]</td>
                            )}
                        </tr>
                    </thead>
                    <tbody className='policy-timeline-table-body'>
                        {
                            yearsKeyData.map((year, index) =>
                                <>
                                    <tr key={index} className='table-row policy-timeline-table-row'>
                                        <td className='font-size-14 border border-dark'>
                                            {index + 1}
                                        </td>
                                        <td className='font-size-14 border border-dark'>
                                            {list?.yearData[year]?.calendar_year}
                                        </td>

                                        {headerList.map((item) =>
                                            <td className={`font-size-14 text-primary ${index == yearsKeyData.length - 1 ? 'policy-table-custom-border' : ""}`}>
                                                <div className={`${index == yearsKeyData.length - 1 ? '' : "policy-table-custom-border"}`}>
                                                    {(list?.yearData[year]?.custom_la_age[item?.la_family_member_id] <= 0 || !list?.yearData[year]?.custom_la_age[item?.la_family_member_id]) ? "" : list?.yearData[year]?.custom_la_age[item?.la_family_member_id] + " Yrs"}
                                                </div>
                                            </td>
                                        )}

                                        {secHeaderList.map((item) =>
                                            <td className={`font-size-14 text-primary ${index == yearsKeyData.length - 1 ? 'policy-table-custom-border' : ""}`}>
                                                <div className={`${index == yearsKeyData.length - 1 ? '' : "policy-table-custom-border"}`}>
                                                    {(list?.yearData[year]?.sec_custom_la_age[item?.sec_la_family_member_id] <= 0 || !list?.yearData[year]?.sec_custom_la_age[item?.sec_la_family_member_id]) ? "" : list?.yearData[year]?.sec_custom_la_age[item?.sec_la_family_member_id] + " Yrs"}
                                                </div>
                                            </td>
                                        )}


                                        <td className={`font-size-14 text-primary ${index == yearsKeyData.length - 1 ? 'policy-table-custom-border' : ""}`}>
                                            <div className={`${index == yearsKeyData.length - 1 ? '' : "policy-table-custom-border"}`}>

                                                {list?.yearData[year]?.custom_total_you_pay <= 0 ? "" : global.toINR(list?.yearData[year]?.custom_total_you_pay)}
                                            </div>
                                        </td>

                                        {list?.show_you_get &&
                                            <td className={`font-size-14 text-primary ${index == yearsKeyData.length - 1 ? 'policy-table-custom-border' : ""}`}>
                                                <div className={`${index == yearsKeyData.length - 1 ? '' : "policy-table-custom-border"}`}>

                                                    {list?.yearData[year]?.custom_total_you_get <= 0 ? "" : global.toINR(list?.yearData[year]?.custom_total_you_get)}
                                                </div>
                                            </td>
                                        }
                                        {headerList.map((item, index) =>
                                            <td className={`font-size-14 text-primary ${index == yearsKeyData.length - 1 ? 'policy-table-custom-border' : ""}`}>
                                                <div className={`${index == yearsKeyData.length - 1 ? '' : "policy-table-custom-border"}`}>

                                                    {(list?.yearData[year]?.custom_la_list[item?.la_family_member_id] <= 0 || !list?.yearData[year]?.custom_la_list[item?.la_family_member_id]) ? "" : global.toINR(list?.yearData[year]?.custom_la_list[item?.la_family_member_id])}
                                                </div>
                                            </td>
                                        )}

                                        {secHeaderList.map((item, index) =>
                                            <td className={`font-size-14 text-primary ${index == yearsKeyData.length - 1 ? 'policy-table-custom-border' : ""}`}>
                                                <div className={`${index == yearsKeyData.length - 1 ? '' : "policy-table-custom-border"}`}>

                                                    {(list?.yearData[year]?.sec_custom_la_list[item?.sec_la_family_member_id] <= 0 || !list?.yearData[year]?.sec_custom_la_list[item?.sec_la_family_member_id]) ? "" : global.toINR(list?.yearData[year]?.sec_custom_la_list[item?.sec_la_family_member_id])}
                                                </div>
                                            </td>
                                        )}
                                    </tr>
                                    {list?.yearData[year]?.custom_product_names.map((item) =>
                                    (item.custom_year_index === index + 1 &&
                                        <tr key={index} className='table-row policy-timeline-table-row'>
                                            <td colSpan="10" className={`font-size-14 text-primary `}>
                                                <div>
                                                    {item?.custom_product_name}  {this.fetchProductEndMessage(item?.custom_product_name)}
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                    )}


                                </>
                            )}

                    </tbody >
                </Table>
                <p className='text-left my-3 font-size-14 text-secondary'>*This table excludes underwriting extra premium, frequency loadings on premiums and riders premium, if any.</p>
            </Card>
        );
    }
});

NewPolicyTimelineTableMultipleLa.defaultProp = {
    isKeypressScrollActive: false
}

export default NewPolicyTimelineTableMultipleLa;